export default "__VITE_ASSET__fbf3e369__"